import { Card, Button, Typography, Row, Col, message } from "antd";
import {
  ArrowRightOutlined,
  PauseOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getHeaderBarColor } from "../../../utils/getHeaderBarColor";
import axiosInstance from "../../../helpers/axiosInstance";
import { formatFecha } from "../../../utils/formatFecha";
import { useState } from "react";
import GETListarDisponibles from "../../../helpers/auditoria-sma/GETListarDisponibles";
import GETJaulaActual from "../../../helpers/jaula/GETJaulaActual";

const TareaActivaWidget = ({ operacionActiva, setOperacionActiva }) => {
  const navigate = useNavigate();
  const [loadingPausa, setLoadingPausa] = useState(false);
  const [loadingNavigate, setLoadingNavigate] = useState(false);
  if (!operacionActiva) return null;

  const barColor = getHeaderBarColor(operacionActiva?.tipo);

  const handlePausar = async () => {
    setLoadingPausa(true);
    if (!operacionActiva?.accionPausa) return;

    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_WMS_BASE_URL}${operacionActiva.accionPausa.url}`,
        null,
        {
          params: { pausa: true },
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response?.data?.codres === 0) {
        setOperacionActiva(null);
        // message.success(response?.data?.descri);
      }
    } catch (error) {
      message.error(error.data.descri);
    } finally {
      setLoadingPausa(false);
    }
  };

  const handleNavigate = async (operacion) => {
    setLoadingNavigate(true);
    try {
      if (operacion.tipo === "Auditar SMA") {
        // Traer todas las disponibles + jaula para armar URL con payload correspondiente
        const response = await GETListarDisponibles();
        if (response?.status !== 200) {
          message.error("Error al obtener las auditorías disponibles");
          return;
        }

        const asm = response.data.find((x) => x.idauds === operacion.codigo);
        if (!asm) {
          message.error("No se encontró la auditoría seleccionada");
          return;
        }

        const responseJaula = await GETJaulaActual();
        if (responseJaula?.status !== 200) {
          message.error("Error al obtener la jaula actual");
          return;
        }

        const basePath = `/auditar-sma/${operacion.codigo}`;
        const searchParams = new URLSearchParams();

        if (responseJaula?.data?.nombre) {
          searchParams.set("jaula", responseJaula.data.nombre);
        }
        // Agregamos un flag solo si es Recepción o Nota de dev
        if (
          asm?.smatip === "Recepcion de Mercadería" ||
          asm?.smatip === "Nota de Devolución"
        ) {
          searchParams.set("recep", "1"); // o "true", pero "1" es más corto
        }

        navigate(`${basePath}?${searchParams.toString()}`);
      } else {
        navigate(operacion.path);
      }
    } catch (error) {
      message.error(
        "Error al abrir la operación activa: " + (error.message || ""),
      );
    } finally {
      setLoadingNavigate(false);
    }
  };

  return (
    <Card
      style={{
        marginBottom: 24,
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
      styles={{ body: { padding: 16 } }}
    >
      <Row align="middle" justify="space-between">
        {/* IZQUIERDA */}
        <Col>
          {/* FILA SUPERIOR: palito + título */}
          <Row align="middle" gutter={8}>
            <Col>
              <div
                style={{
                  width: 6,
                  height: 24,
                  backgroundColor: barColor,
                  borderRadius: 2,
                }}
              />
            </Col>

            <Col>
              <Typography.Text strong style={{ fontSize: 22 }}>
                {operacionActiva.titulo}
              </Typography.Text>
            </Col>
          </Row>

          {/* FILA INFERIOR: código */}
          <Typography.Text type="secondary" style={{ marginLeft: 14 }}>
            {formatFecha(operacionActiva.fecha)}
          </Typography.Text>
        </Col>

        {/* DERECHA */}
        <Col>
          <Row gutter={8}>
            <Col>
              <Button
                size="large"
                type="primary"
                style={{ backgroundColor: "#fb9a1a", borderColor: "#fb9a1a" }}
                icon={<ArrowRightOutlined />}
                onClick={() => handleNavigate(operacionActiva)}
                loading={loadingNavigate}
              />
            </Col>
            <Col>
              <Button
                size="large"
                type="text"
                loading={loadingPausa}
                icon={
                  loadingPausa ? (
                    <SyncOutlined spin />
                  ) : (
                    <PauseOutlined style={{ fontSize: 31 }} />
                  )
                }
                onClick={handlePausar}
                disabled={loadingPausa}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default TareaActivaWidget;
